type CashChange = {
  T: number;
  P: number;
  V: number;
  C: number;
  I: number;
  Cbm: number;
  Cmr: number;
  Cr: number;
  Nwbm: number;
  Nwmr: number;
  Wbm: number;
  Wmr: number;
  UsedCredit: number;
};

function transformCashChange(data: CashChange) {
  const {
    T: totalAsset,
    P: buyingPower,
    V: blockedValue,
    C: investorBourseCodeId,
    I: investorBourseCodeIsin,
    Cbm: creditBlockedMoney,
    Cmr: creditMoneyRemain,
    Cr: creditMoney,
    Nwbm: nonWithdrawableBlockedMoney,
    Nwmr: nonWithdrawableMoneyRemain,
    Wbm: withdrawableBlockedMoney,
    Wmr: withdrawableMoneyRemain,
    UsedCredit: usedCredit,
  } = data;

  return {
    totalAsset,
    buyingPower: Math.floor(buyingPower),
    blockedValue,
    creditBlockedMoney,
    creditMoneyRemain,
    creditMoney,
    nonWithdrawableBlockedMoney,
    nonWithdrawableMoneyRemain,
    withdrawableBlockedMoney,
    withdrawableMoneyRemain,
    investorBourseCodeIsin,
    investorBourseCodeId,
    usedCredit,
  };
}

export { transformCashChange };
